<template>
  <div
    class="culturalMore"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="culturalMoreTop">
      <div class="section eng_section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="culturalMoreGoods"
            >Cultural and creative products</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.englishName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalMoreContont">
      <div class="section">
        <div class="detail">
          <div class="left">
            <img v-if="item.pictures" :src="url + item.pictures[0].fileUrl" alt="" />
            <img v-else src="" alt="" />
          </div>
          <div class="right">
            <div class="title">
              {{ item.englishName }}
              <span class="itemLink" v-if="item.link"
                ><a :href="item.link" target="_blank">Purchase links</a></span
              >
            </div>
            <div class="price">
              Price：<span>￥{{ item.price }}</span>
            </div>
            <div class="introduce">
              <div v-html="item.englishContent"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-popover placement="left" width="250" trigger="hover">
      <div class="tel">Qinghai Zhumuyaru Digital Technology Co., Ltd.</div>
      <div class="tel">Mr Tao: 18308018896</div>
      <div class="tel">E-mail: huanshu@yarlung.cn</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">Cultural and Creative Consulting</div>
          <div class="hidden-sm-and-up">Cultural and Creative Consulting</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="culturalMore" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="culturalMoreTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="culturalMoreGoods"> རིག་གཏོད་ཐོན་རྫས།</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.zangName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalMoreContont">
      <div class="section">
        <div class="detail">
          <div class="left">
            <img v-if="item.pictures" :src="url + item.pictures[0].fileUrl" alt="" />
            <img v-else src="" alt="" />
          </div>
          <div class="right">
            <div class="title">
              {{ item.zangName }}
              <span class="itemLink" v-if="item.link"
                ><a :href="item.link" target="_blank"
                  >ཉོ་ཆའི་སྦྲེལ་གནས།
                </a></span
              >
            </div>
            <div class="price">
              རིན་གོང་།<span>￥{{ item.price }}</span>
            </div>
            <div class="introduce">
              <div v-html="item.zangContent"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">མཚོ་སྔོན་ཇོ་མ་ཡར་ཀླུང་གྲངས་འཛིན་ཚན་རྩལ་ཚད་ཡོད་ཀུང་སི།</div>
      <div class="tel">དགེ་རྒན་ཐོའོ། 18308018896</div>
      <div class="tel">ཡིག་ཟམ། huanshu@yarlung.cn</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">རིག་གཏོད་འདྲི་རྩད།</div>
          <div class="hidden-sm-and-up">རིག་གཏོད་འདྲི་རྩད།</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="culturalMore" v-else>
    <Pic-top></Pic-top>
    <div class="culturalMoreTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="culturalMoreGoods">文创产品</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.chineseName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalMoreContont">
      <div class="section">
        <div class="detail">
          <div class="left">
            <img v-if="item.pictures" :src="url + item.pictures[0].fileUrl" alt="" />
            <img v-else src="" alt="" />
          </div>
          <div class="right">
            <div class="title">
              {{ item.chineseName }}
              <span class="itemLink" v-if="item.link"
                ><a :href="item.link" target="_blank">购买链接</a></span
              >
            </div>
            <div class="price">
              价格：<span>￥{{ item.price }}</span>
            </div>
            <div class="introduce">
              <div v-html="item.chineseContent"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">青海珠穆雅鲁数字科技有限公司</div>
      <div class="tel">陶老师：18308018896</div>
      <div class="tel">邮箱：huanshu@yarlung.cn</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">文创咨询</div>
          <div class="hidden-sm-and-up">文创咨询</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { goodsGet } from "../../api/management";
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      language: this.$store.state.language,
      num: 1,
      url: process.env.VUE_APP_WEB_URL,
      name: "全部",
      id: this.$route.query.id,
      item: {},
      templeContact:'18997193666'
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  methods: {
    async getGoodDetail() {
      const res = await goodsGet(this.id);
      this.item = res.data;
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    new this.$wow.WOW().init();
  },
  created() {
    this.getGoodDetail();
  },
};
</script>
<style lang="scss">
.culturalMore {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .culturalMoreTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .culturalMoreContont {
    margin: 50px 0;
    position: relative;
    .section {
      .detail {
        display: flex;
        .left {
          width: 380px;
          img {
            width: 100%;
          }
        }
        .right {
          width: 820px;
          padding: 10px 20px;
          .title {
            font-size: 26px;
            .itemLink {
              a {
                font-size: 18px;
                color: #007acc !important;
                margin-left: 10px;
                text-decoration: underline;
              }
            }
          }
          .price {
            font-size: 26px;
            margin: 10px 0;
            span {
              color: #c80035;
            }
          }
          .count {
            display: flex;
            align-items: center;
            font-size: 26px;
          }
          .introduce {
            margin-top: 10px;
            font-size: 20px;
            line-height: 30px;
            text-align: justify;
          }
        }
      }
    }
  }
  .contact {
    z-index: 999;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .message {
      padding: 0 10px;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      margin-bottom: 20px;
      box-shadow: 0 0 10px #99131a;
      font-size: 12px;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
}
@media (max-width: 768px) {
  .culturalMore {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .culturalMoreTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .eng_section {
        font-size: 0.26rem;
      }
      .moblieCloudLeft {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .culturalMoreContont {
      margin: 0.5rem 0;
      .section {
        .detail {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .left {
            width: 90%;
            img {
              width: 100%;
            }
          }
          .right {
            width: 90%;
            padding: 20px 10px;
            .title,
            .price,
            .count {
              font-size: 0.35rem !important;
              a {
                font-size: 0.3rem !important;
                margin-left: 0.2rem;
              }
            }
            .el-input-number {
              width: 2rem;
            }
            .introduce {
              font-size: 0.3rem;
              line-height: 0.45rem;
            }
          }
        }
      }
    }
    .contact {
      right: 1%;
      bottom: 35%;
      z-index: 1000;
      .message {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
